/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ExternalCostRowDtoToJSON, OtherCostListDtoFromJSON, ShiftScheduleInputDtoToJSON, UpdateCostsInputDtoFromJSON, UpdateCostsInputDtoToJSON, WbsDtoFromJSON, WbsDtoToJSON, WbsInputListDtoToJSON, WbsListDtoFromJSON, WbsPlanningDtoFromJSON, WbsPlanningInputDtoToJSON, } from '../models/index';
/**
 *
 */
export class PlanningControllerApi extends runtime.BaseAPI {
    /**
     * Consente al PL o SUPER ADMIN di clonare staff e costi esterni da un progetto ad un altro
     * Clona staff e costi esterni
     */
    cloneStaffAndExternalCostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['sourceIdProject'] == null) {
                throw new runtime.RequiredError('sourceIdProject', 'Required parameter "sourceIdProject" was null or undefined when calling cloneStaffAndExternalCost().');
            }
            if (requestParameters['targetIdProject'] == null) {
                throw new runtime.RequiredError('targetIdProject', 'Required parameter "targetIdProject" was null or undefined when calling cloneStaffAndExternalCost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/{sourceIdProject}/clone-staff-externalCost/{targetIdProject}`.replace(`{${"sourceIdProject"}}`, encodeURIComponent(String(requestParameters['sourceIdProject']))).replace(`{${"targetIdProject"}}`, encodeURIComponent(String(requestParameters['targetIdProject']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OtherCostListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Consente al PL o SUPER ADMIN di clonare staff e costi esterni da un progetto ad un altro
     * Clona staff e costi esterni
     */
    cloneStaffAndExternalCost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cloneStaffAndExternalCostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Crea o aggiorna una WBS utilizzando i dati forniti.
     * Crea o aggiorna una WBS
     */
    createOrUpdateWbsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['wbsDto'] == null) {
                throw new runtime.RequiredError('wbsDto', 'Required parameter "wbsDto" was null or undefined when calling createOrUpdateWbs().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbs/save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: WbsDtoToJSON(requestParameters['wbsDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => WbsDtoFromJSON(jsonValue));
        });
    }
    /**
     * Crea o aggiorna una WBS utilizzando i dati forniti.
     * Crea o aggiorna una WBS
     */
    createOrUpdateWbs(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createOrUpdateWbsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Crea o aggiorna un Planning WBS utilizzando i dati forniti.
     * Crea o aggiorna un planning WBS
     */
    createOrUpdateWbsPlanningRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['wbsInputListDto'] == null) {
                throw new runtime.RequiredError('wbsInputListDto', 'Required parameter "wbsInputListDto" was null or undefined when calling createOrUpdateWbsPlanning().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbsPlanning/saveAndUpdate`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['wbsInputListDto'].map(WbsInputListDtoToJSON),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WbsListDtoFromJSON));
        });
    }
    /**
     * Crea o aggiorna un Planning WBS utilizzando i dati forniti.
     * Crea o aggiorna un planning WBS
     */
    createOrUpdateWbsPlanning(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createOrUpdateWbsPlanningRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Crea o aggiorna un Planning WBS utilizzando i dati forniti.
     * Crea o aggiorna un planning WBS
     */
    createOrUpdateWbsPlanning1Raw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['wbsPlanningInputDto'] == null) {
                throw new runtime.RequiredError('wbsPlanningInputDto', 'Required parameter "wbsPlanningInputDto" was null or undefined when calling createOrUpdateWbsPlanning1().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbsPlanning/save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: WbsPlanningInputDtoToJSON(requestParameters['wbsPlanningInputDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => WbsPlanningDtoFromJSON(jsonValue));
        });
    }
    /**
     * Crea o aggiorna un Planning WBS utilizzando i dati forniti.
     * Crea o aggiorna un planning WBS
     */
    createOrUpdateWbsPlanning1(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createOrUpdateWbsPlanning1Raw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Elimina costi esterni utilizzando i dati forniti.
     * Elimina costi esterni
     */
    deleteCostsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['externalCostRowDto'] == null) {
                throw new runtime.RequiredError('externalCostRowDto', 'Required parameter "externalCostRowDto" was null or undefined when calling deleteCosts().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/delete-other-costs/`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['externalCostRowDto'].map(ExternalCostRowDtoToJSON),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Elimina costi esterni utilizzando i dati forniti.
     * Elimina costi esterni
     */
    deleteCosts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteCostsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Elimina una WBS in base all\'ID fornito.
     * Elimina una WBS
     */
    deleteWbsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteWbs().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Elimina una WBS in base all\'ID fornito.
     * Elimina una WBS
     */
    deleteWbs(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteWbsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Elimina un planning WBS in base all\'ID fornito.
     * Elimina un planning wbs
     */
    deleteWbsPlanningRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteWbsPlanning().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbsPlanning/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Elimina un planning WBS in base all\'ID fornito.
     * Elimina un planning wbs
     */
    deleteWbsPlanning(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteWbsPlanningRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Elimina un planning WBS in base all\'ID fornito.
     * Elimina un planning wbs
     */
    deleteWbsPlanningAndWbsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteWbsPlanningAndWbs().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbsPlanning/wbs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Elimina un planning WBS in base all\'ID fornito.
     * Elimina un planning wbs
     */
    deleteWbsPlanningAndWbs(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteWbsPlanningAndWbsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Recupera l\'elenco di tutte le WBS.
     * Recupera tutte le WBS
     */
    getAllWbsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbs/all`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => WbsDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera l\'elenco di tutte le WBS.
     * Recupera tutte le WBS
     */
    getAllWbs(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllWbsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera i planning WBS.
     * Recupera tutti i planning dei WBS
     */
    getAllWbsPlanningRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbsPlanning/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WbsPlanningDtoFromJSON));
        });
    }
    /**
     * Recupera i planning WBS.
     * Recupera tutti i planning dei WBS
     */
    getAllWbsPlanning(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllWbsPlanningRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i planning WBS con l\'id del wbs.
     * Recupera tutti i planning del WBS dall\'id del wbs
     */
    getAllWbsPlanningByWbsIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getAllWbsPlanningByWbsId().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbsPlanning/wbs_id/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WbsPlanningDtoFromJSON));
        });
    }
    /**
     * Recupera tutti i planning WBS con l\'id del wbs.
     * Recupera tutti i planning del WBS dall\'id del wbs
     */
    getAllWbsPlanningByWbsId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllWbsPlanningByWbsIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera l\'elenco delle WBS e il planning associate a un determinato progetto.
     * Recupera le WBS e il planning per project id
     */
    getWbsAndPlanningByProjectIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getWbsAndPlanningByProjectId().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbs/projectPlanning/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WbsListDtoFromJSON));
        });
    }
    /**
     * Recupera l\'elenco delle WBS e il planning associate a un determinato progetto.
     * Recupera le WBS e il planning per project id
     */
    getWbsAndPlanningByProjectId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getWbsAndPlanningByProjectIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera l\'elenco delle WBS associate a un determinato progetto.
     * Recupera le WBS per project id
     */
    getWbsByProjectIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getWbsByProjectId().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbs/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => WbsDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera l\'elenco delle WBS associate a un determinato progetto.
     * Recupera le WBS per project id
     */
    getWbsByProjectId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getWbsByProjectIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera il planning WBS con l\'id.
     * Recupera tutte il planning del WBS dall\'id
     */
    getWbsPlanningByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getWbsPlanningById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/wbsPlanning/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => WbsPlanningDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera il planning WBS con l\'id.
     * Recupera tutte il planning del WBS dall\'id
     */
    getWbsPlanningById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getWbsPlanningByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Invia il planning a Salesforce/intranet e aggiorna lo stato del progetto
     * Invia planning
     */
    inviaPlanningRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling inviaPlanning().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Invia il planning a Salesforce/intranet e aggiorna lo stato del progetto
     * Invia planning
     */
    inviaPlanning(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.inviaPlanningRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Aggiorna la pianificazione del progetto selezionato
     * Aggiorna la pianificazione di un progetto
     */
    ripianificaRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling ripianifica().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/ripianifica/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Aggiorna la pianificazione del progetto selezionato
     * Aggiorna la pianificazione di un progetto
     */
    ripianifica(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.ripianificaRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Aggiorna staff e costi esterni utilizzando i dati forniti.
     * Aggiorna staff e costi esterni
     */
    saveScheduleRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling saveSchedule().');
            }
            if (requestParameters['updateCostsInputDto'] == null) {
                throw new runtime.RequiredError('updateCostsInputDto', 'Required parameter "updateCostsInputDto" was null or undefined when calling saveSchedule().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/save-schedule/project/{idProject}`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateCostsInputDtoToJSON(requestParameters['updateCostsInputDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCostsInputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Aggiorna staff e costi esterni utilizzando i dati forniti.
     * Aggiorna staff e costi esterni
     */
    saveSchedule(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveScheduleRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Trasla costi e/o ricavi del progetto in avanti o indietro di n mesi.
     * Trasla pianificazione di un progetto
     */
    shiftScheduleRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling shiftSchedule().');
            }
            if (requestParameters['shiftScheduleInputDto'] == null) {
                throw new runtime.RequiredError('shiftScheduleInputDto', 'Required parameter "shiftScheduleInputDto" was null or undefined when calling shiftSchedule().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/shift-schedule/project/{idProject}`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ShiftScheduleInputDtoToJSON(requestParameters['shiftScheduleInputDto']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Trasla costi e/o ricavi del progetto in avanti o indietro di n mesi.
     * Trasla pianificazione di un progetto
     */
    shiftSchedule(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shiftScheduleRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Aggiorna staff e costi esterni utilizzando i dati forniti.
     * Aggiorna staff e costi esterni
     */
    updateCostsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling updateCosts().');
            }
            if (requestParameters['updateCostsInputDto'] == null) {
                throw new runtime.RequiredError('updateCostsInputDto', 'Required parameter "updateCostsInputDto" was null or undefined when calling updateCosts().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/planning/update/project/{idProject}`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateCostsInputDtoToJSON(requestParameters['updateCostsInputDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCostsInputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Aggiorna staff e costi esterni utilizzando i dati forniti.
     * Aggiorna staff e costi esterni
     */
    updateCosts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateCostsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
